import store from '@/store/store'
import _ from 'lodash'

export enum ELevel {
  ADMIN = 'all',
  CENTER = 'center',
  USER = 'user',
}
export interface Menu {
  icon: string,
  title: string,
  route?: string,
  children?: Menu,
  color?: string,
  padding?: number,
  'border-radius'?: number,
  excludePermission?: boolean
}

export interface MenuPermission {
  [key: string]: Menu
}

const ADMIN_MENU: Menu[] = [
  {
    icon: 'monitor-dashboard',
    title: 'ข้อมูลสรุป',
    route: 'dashboard',
  },
  // {
  //   icon: 'currency-usd',
  //   title: 'รายได้นักบริบาล',
  //   route: 'payment-history/caregiver',
  // },
  // {
  //   icon: 'currency-usd',
  //   title: 'รายได้ศูนย์บริการ',
  //   route: 'payment-history/center',
  // },
  {
    icon: 'account-circle',
    title: 'ผู้ใช้งานทั้งหมด',
    route: 'user',
  },
  {
    icon: 'store',
    title: 'สาขาศูนย์บริการ',
    route: 'center',
  },
  {
    icon: 'home-account',
    title: 'ผู้ดูแลประจำศูนย์บริการ',
    route: 'leader',
  },
  {
    icon: 'account-multiple',
    title: 'เจ้าหน้าที่',
    route: 'staff',
  },
  {
    icon: 'doctor',
    title: 'นักบริบาล',
    route: 'caregiver',
  },
  {
    icon: 'seat-individual-suite',
    title: 'ผู้สูงอายุ/ผู้ป่วย',
    route: 'patient',
  },
  // {
  //   icon: 'format-list-bulleted-type',
  //   title: 'ประเภทบริการ',
  //   route: 'job-type',
  // },
  // {
  //   icon: 'calendar-clock',
  //   title: 'เวลาปฏิบัติงาน',
  //   route: 'working-time',
  // },
  // {
  //   icon: 'hexagon-slice-4',
  //   title: 'สถานะผู้สูงอายุ/ผู้ป่วย',
  //   route: 'patient-status',
  // },
  // {
  //   icon: 'cash-register',
  //   title: 'ราคาการใช้บริการ',
  //   route: 'price',
  // },
  {
    icon: 'ballot-recount',
    title: 'ลำดับคิวนักบริบาล',
    route: 'schedule',
  },
  {
    icon: 'file-document',
    title: 'การจ่ายงาน',
    route: 'job',
  },
  {
    icon: 'file-sign',
    title: 'สัญญา 4 เดือน',
    route: 'monthly-contract',
    excludePermission: true,
  },
  {
    icon: 'cellphone-wireless',
    title: 'เบอร์โทรฉุกเฉิน',
    route: 'sos',
  },
  {
    icon: 'checkbook',
    title: 'บัญชีธนาคาร',
    route: 'payment',
  },
  {
    icon: 'credit-card-clock-outline',
    title: 'ประวัติชำระเงิน',
    route: 'payment-history',
  },
  {
    icon: 'account-key',
    title: 'สิทธิใช้งานในระบบ',
    route: 'permission',
  },
  {
    icon: 'account-details',
    title: 'หน้าที่',
    route: 'role',
  },
  // {
  //   icon: 'file-tree',
  //   title: 'สัญญาทำงาน',
  //   route: 'campaign',
  // },
]

const CENTER_MENU: Menu[] = [
  {
    icon: 'monitor-dashboard',
    title: 'ข้อมูลสรุป',
    route: 'dashboard',
  },
  // {
  //   icon: 'currency-usd',
  //   title: 'รายได้นักบริบาล',
  //   route: 'payment-history/caregiver',
  // },
  // {
  //   icon: 'account-key',
  //   title: 'สิทธิใช้งานในระบบ',
  //   route: 'permission',
  // },
  // {
  //   icon: 'account-details',
  //   title: 'หน้าที่',
  //   route: 'role',
  // },
  // {
  //   icon: 'account-circle',
  //   title: 'ผู้ขอรับบริการ',
  //   route: 'user',
  // },
  // {
  //   icon: 'store',
  //   title: 'สาขาศูนย์บริการ',
  //   route: 'center',
  // },
  {
    icon: 'account-multiple',
    title: 'เจ้าหน้าที่',
    route: 'staff',
  },
  {
    icon: 'doctor',
    title: 'นักบริบาล',
    route: 'caregiver',
  },
  {
    icon: 'seat-individual-suite',
    title: 'ผู้สูงอายุ/ผู้ป่วย',
    route: 'patient',
  },
  // {
  //   icon: 'cash-register',
  //   title: 'ราคาการใช้บริการ',
  //   route: 'price',
  // },
  {
    icon: 'ballot-recount',
    title: 'ลำดับคิวนักบริบาล',
    route: 'schedule',
  },
  {
    icon: 'file-document',
    title: 'การจ่ายงาน',
    route: 'job',
  },
  {
    icon: 'file-sign',
    title: 'สัญญา 4 เดือน',
    route: 'monthly-contract',
    excludePermission: true,
  },
  {
    icon: 'checkbook',
    title: 'บัญชีธนาคาร',
    route: 'payment',
  },
  {
    icon: 'credit-card-clock-outline',
    title: 'ประวัติชำระเงิน',
    route: 'payment-history',
  },
  // {
  //   icon: 'file-tree',
  //   title: 'สัญญาทำงาน',
  //   route: 'campaign',
  // },
]

const SELF_MENU = [
  {
    icon: 'seat-individual-suite',
    title: 'ผู้สูงอายุ/ผู้ป่วย',
    route: 'patient',
  },
  {
    icon: 'file-document',
    title: 'ข้อมูลบริการ',
    route: 'job',
  },
  {
    icon: 'file-sign',
    title: 'สัญญา 4 เดือน',
    route: 'monthly-contract',
    excludePermission: true,
  },
  {
    icon: 'ballot-recount',
    title: 'การจ่ายงาน',
    route: 'schedule',
  },
]

export function getMenu(): Menu[] {
  const profile = store.state.userprofile.profile
  const user = store.state.components.user

  const level = user && user.level
    ? user.level.mode
    : ELevel.USER
  const menus = {
    [ELevel.ADMIN]: ADMIN_MENU,
    [ELevel.CENTER]: CENTER_MENU,
    [ELevel.USER]: SELF_MENU,
  }
  if ((level === ELevel.ADMIN) && (profile.userId === 'U8199ed4289cc8eb9721481216f514391')) {
    menus[level] = menus[level].concat([
      {
        icon: 'account-key',
        title: 'สิทธิใช้งานในระบบ',
        route: 'permission',
      },
      {
        icon: 'account-details',
        title: 'หน้าที่',
        route: 'role',
      },
    ])
  }
  return _.filter(menus[level], (menu) => {
    const [key] = menu.route.split('/')
    return menu.excludePermission || _.find(profile.permissions, {key, level})
  })
}
